export default "__VITE_ASSET__DCaUl$c6__"